import { render, staticRenderFns } from "./DashboardPlanItem.vue?vue&type=template&id=2b03b8f6"
import script from "./DashboardPlanItem.vue?vue&type=script&lang=ts"
export * from "./DashboardPlanItem.vue?vue&type=script&lang=ts"
import style0 from "./DashboardPlanItem.vue?vue&type=style&index=0&id=2b03b8f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports